module.exports = __webpack_public_path__ + "static/img/img2.638635a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/img2.png
// module id = 5vdT
// module chunks = 1